/**
 * The PageTitle component displays the title of a page.
 * The title/heading is passed in as children elements
 */
const PageTitle = props => (
	<h2>{ props.children }</h2>
);

export default PageTitle;



// WEBPACK FOOTER //
// ./components/page-title/index.js